export default "__VITE_ASSET__DFX$bj0F__"